<template>
  <div class="about">
    <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
        
        :is-full-page="fullPage"></loading>
    <h1>This is an about page</h1>
    
  </div>
  
</template>
<script>
import Vue from 'vue'
 import axios from 'axios';
 import Loading from 'vue-loading-overlay';
    // Import stylesheet
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';

// @ is an alias to /src

export default {
  components: {
            Loading
        },
   
  data () {
    return {
      isLoading: false,
      fullPage: true,
      page:{
          name : 'Wish List',
          intro : 'Welcome to'

      },
      snackbar: {
                show: false,
                message: null,
                color: null
       },
      title:'',
    
    }
  },
  mounted(){
    this.$parent.$children[0].$parent.ttlval = this.page.name
    console.log(this.$parent.$children[0].$parent.ttlval)
  }
}
</script>